var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSubmitIcon = function SvgSubmitIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.144,
    height: 31.14
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "submit-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e71019",
    d: "M-3-3h31.14v31.144H-3z",
    "data-name": "Rectangle 90"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 66"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#e71019",
    clipPath: "url(#submit-icon_svg__a)",
    "data-name": "Group 61",
    transform: "rotate(-90 15.57 12.57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.578 25.144A12.572 12.572 0 1 1 25.14 12.632a12.566 12.566 0 0 1-12.562 12.512m0-.7A11.873 11.873 0 1 0 .7 12.553a11.856 11.856 0 0 0 11.874 11.891",
    "data-name": "Path 221"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.571 15.888a6 6 0 0 1-.535-.274c-2.339-1.517-4.679-3.032-7-4.569-.2-.133-.3-.419-.451-.634.276.016.614-.067.819.062 2.112 1.332 4.229 2.659 6.284 4.077a1.37 1.37 0 0 0 1.826-.032c2.019-1.367 4.077-2.678 6.136-3.985a2.4 2.4 0 0 1 .829-.162c-.133.24-.206.572-.409.705-2.327 1.534-4.674 3.039-7.017 4.549-.144.093-.3.166-.478.262",
    "data-name": "Path 222"
  })))));
};
export default SvgSubmitIcon;